import { Ds } from "@accurx/design";
import { MessageActionsControlBar } from "domains/message-component/components/Compose/components/MessageActionsControlBar/MessageActionsControlBar";

import { ComposeActionStack } from "../../ComposeActionStack";
import { MessageEditorProps } from "../../types/Compose.types";
import { ComposeTextArea } from "../ComposeTextArea/ComposeTextArea";
import { ScheduledSendInfo } from "../ScheduledSendInfo/ScheduledSendInfo";
import { StillLoadingErrors } from "../StillLoadingErrors/StillLoadingErrors";
import {
    StyledMessageEditorContainer,
    StyledMessageEditorTitle,
} from "./MessageEditor.styles";

export const MessageEditor = ({
    onUserTyping,
    assigneeSelector,
    assigneeLabel,
    setAssignee,
    patient,
    ...props
}: MessageEditorProps) => {
    return (
        <>
            <StyledMessageEditorContainer
                $hasVisualBox={!!props.showMultipleMessagesUi}
            >
                {props.showMultipleMessagesUi && (
                    <StyledMessageEditorTitle>
                        <Ds.Text weight="bold">{props.editorTitle}</Ds.Text>
                        <Ds.Button
                            className="ml-auto"
                            appearance="secondary"
                            size="small"
                            onClick={props.onClickRemove}
                        >
                            Remove
                        </Ds.Button>
                    </StyledMessageEditorTitle>
                )}
                <Ds.Flex flexDirection="column" gap="1">
                    <ComposeTextArea onUserTyping={onUserTyping} />
                    <ComposeActionStack
                        assigneeLabel={
                            assigneeSelector ?? (
                                <Ds.Badge
                                    radius="round"
                                    color="greyscale"
                                    data-testid="assignee-label"
                                >
                                    <strong>{assigneeLabel}</strong>
                                </Ds.Badge>
                            )
                        }
                    />
                </Ds.Flex>
                <StillLoadingErrors />
                <ScheduledSendInfo />
                {props.showMultipleMessagesUi && (
                    <Ds.Flex
                        data-testid="message-actions-control-bar"
                        justifyContent="flex-start"
                        flexWrap={"wrap"}
                        gap={"1"}
                    >
                        <MessageActionsControlBar
                            setAssignee={setAssignee}
                            patient={patient}
                        />
                    </Ds.Flex>
                )}
            </StyledMessageEditorContainer>
        </>
    );
};
